import {MenuItem} from '@/scripts/types/helper';

const breadcrumbs = ref<MenuItem[]>();

export const useHeader = () => {
	const setBreadcrumbs = (newBreadcrumbs: MenuItem[]) => {
		breadcrumbs.value = newBreadcrumbs.map((b) => ({
			...b,
			key: crypto.randomUUID(),
		}));
	};

	return {setBreadcrumbs, breadcrumbs};
};
